import React from 'react';
import PropTypes from 'prop-types';
import { IconFileInvoice, IconCurrencyDollar, IconClock, IconAlertTriangle } from '@tabler/icons-react';

const InvoiceStats = ({ factures }) => {
  const stats = {
    totalInvoices: factures.length,
    totalRevenue: factures.reduce((sum, f) => sum + ((f.total || f.totalTTC) || 0), 0).toFixed(2),
    pendingInvoices: factures.filter(f => f.status === 'draft').length,
    overdueInvoices: factures.filter(f => f.dueDate && new Date(f.dueDate) < new Date() && f.status !== 'paid').length,
  };

  const cards = [
    { label: 'Total Factures', value: stats.totalInvoices, icon: <IconFileInvoice size={20} strokeWidth={1.5} className="text-blue-600" />, bg: 'bg-blue-50' },
    { label: "Chiffre d'Affaires", value: `${stats.totalRevenue} DT`, icon: <IconCurrencyDollar size={20} strokeWidth={1.5} className="text-green-600" />, bg: 'bg-green-50' },
    { label: 'En attente', value: stats.pendingInvoices, icon: <IconClock size={20} strokeWidth={1.5} className="text-yellow-600" />, bg: 'bg-yellow-50' },
    { label: 'En retard', value: stats.overdueInvoices, icon: <IconAlertTriangle size={20} strokeWidth={1.5} className="text-red-600" />, bg: 'bg-red-50' },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {cards.map(({ label, value, icon, bg }) => (
        <div key={label} className="bg-white rounded-xl border border-gray-200 p-4 flex items-center gap-3">
          <div className={`${bg} p-2.5 rounded-lg flex-shrink-0`}>{icon}</div>
          <div>
            <p className="text-xs text-gray-500">{label}</p>
            <p className="text-xl font-bold text-gray-800">{value}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

InvoiceStats.propTypes = {
  factures: PropTypes.arrayOf(PropTypes.shape({ total: PropTypes.number, totalTTC: PropTypes.number, status: PropTypes.string, dueDate: PropTypes.string })).isRequired,
};

export default InvoiceStats;
